namespace SP {
    export interface WarehouseActionInfo {
        id: string,
        name: string,
        returnActionType : ReturnActionType,
        defaultAction: boolean,
    }
}